import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarFour = _resolveComponent("NavbarFour")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_TopMoviesToday = _resolveComponent("TopMoviesToday")!
  const _component_UpcomingMovies = _resolveComponent("UpcomingMovies")!
  const _component_TopRatedToday = _resolveComponent("TopRatedToday")!
  const _component_WhatMadeExtraordinary = _resolveComponent("WhatMadeExtraordinary")!
  const _component_EnjoyTheAllMovies = _resolveComponent("EnjoyTheAllMovies")!
  const _component_SpecialMovies = _resolveComponent("SpecialMovies")!
  const _component_PartnerLogo = _resolveComponent("PartnerLogo")!
  const _component_RecommendedForYou = _resolveComponent("RecommendedForYou")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_SubscribeNow = _resolveComponent("SubscribeNow")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarFour, {
      class: "movie-home-navbar",
      className: "container-fluid",
      autoStyle: "m-auto"
    }),
    _createVNode(_component_MainBanner),
    _createVNode(_component_TopMoviesToday),
    _createVNode(_component_UpcomingMovies),
    _createVNode(_component_TopRatedToday),
    _createVNode(_component_WhatMadeExtraordinary),
    _createVNode(_component_EnjoyTheAllMovies),
    _createVNode(_component_SpecialMovies),
    _createVNode(_component_PartnerLogo),
    _createVNode(_component_RecommendedForYou),
    _createVNode(_component_FAQ),
    _createVNode(_component_SubscribeNow),
    _createVNode(_component_MainFooter, {
      class: "bg-secondary bg-img",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
    }, null, 8, ["style"]),
    _createVNode(_component_CopyRight)
  ], 64))
}